import ContactHelpers from '../helpers/ContactHelpers'
import DataHelpers from '../helpers/DataHelpers'
import Firestore from '../data/Firestore'

import firebase from 'firebase/app'
import 'firebase/auth'

import Vue from 'vue'
import StringHelpers from './StringHelpers'
import NiceData from '../data/NiceData'

const SETTINGS_COLLECTION = 'teamSettings'

export default class {

    static fetchUserId () {
        return new Promise((resolve, reject) => {
            console.log('TeamHelpers > fetchUserId')
            let user = firebase.auth().currentUser
            if(user)
                resolve(user.uid)
            else
                setTimeout(() => {
                    this.fetchUserId().then(uid => {
                        resolve(uid)
                    })
                }, 300);
        })       
    }

    // static fetchUser(vm) {
    //     return new Promise( (resolve, reject) => {
    //         if(firebase.auth().currentUser) {
    //             console.log('User was immediately available', firebase.auth().currentUser)
    //             resolve(firebase.auth().currentUser)  
    //         }
    //         else
    //             vm.$eventBus.$on('signed-in', () => {
    //                 console.log('User was notified via bus', firebase.auth().currentUser)
    //                 resolve(firebase.auth().currentUser)  
    //             })          
    //     })
    // }

    static setPrimaryTeam(name) {
        const uid = DataHelpers.getUserId()
        const user = {
            _id: uid,
            _path: `users`,
            primaryTeam: name,
        }
        Firestore.saveItem(user)
    }

    static streamUser(user) {
        const uid = DataHelpers.getUserId()
        const ref = Firestore.getFirestore().doc(`users/${uid}`)
        Firestore.streamDocument(ref, user)
    }

    //todo: remove primary attribute below

    static async fetchActiveTeams() {
        const uid = await this.fetchUserId()
        const ref = Firestore.getCollectionDocumentRefFromPath(`users/${uid}/teams`).where('active', '==', true)
        return Firestore.fetchCollection(ref)
    }

    static activateTeam(name, primary) {
        const uid = DataHelpers.getUserId()
        const team = {
            _id: name,
            _path: `users/${uid}/teams`,
            active: true,
            primary: Firestore.deleteToken()
        }
        Firestore.saveItem(team)
    }

    static deactivateTeam(name) {
        const uid = DataHelpers.getUserId()
        const team = {
            _id: name,
            _path: `users/${uid}/teams`,
            active: false,
            primary: Firestore.deleteToken(),
        }
        Firestore.saveItem(team)
    }

    static async officeNumberToName(number) {
        const ref = DataHelpers.getRootRef().child(`invites/${number}/name`)
        return NiceData.fetchValue(ref)                     //returns promise
    }

    static async fetchTeamName() {
        const officeNumber = DataHelpers.getTenantKey()
        const officeName = await this.officeNumberToName(officeNumber)
        const teamName = StringHelpers.toCamelCase(officeName)
        return teamName
    }

    static async saveTeamSettings(settings) {
        const officeNumber = DataHelpers.getTenantKey()
        const officeName = await this.officeNumberToName(officeNumber)
        settings._team = StringHelpers.toCamelCase(officeName)
        settings._collection = SETTINGS_COLLECTION
        settings._id = 'settings'
        
        Firestore.saveItem(settings)
    }

    static async fetchTeamSettings() {
        return new Promise(async (resolve, reject) => {
            const officeNumber = DataHelpers.getTenantKey()
            const officeName = await this.officeNumberToName(officeNumber)
            const team = StringHelpers.toCamelCase(officeName)
            const ref = Firestore.getCollectionDataRef(team, SETTINGS_COLLECTION)
            const settingsArr = await Firestore.fetchCollection(ref)
            let settings = {}
            if(settingsArr.length)
                settings = settingsArr[0]        
            resolve(settings)
        })
    }
}


// WEBPACK FOOTER //
// ./src/helpers/TeamHelpers.js